exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".track-change-overlay .Dropdown__item-TrackChange{display:flex;flex-direction:column}.track-change-overlay .Dropdown__item-TrackChange .Dropdown__item-mode{font-weight:700;text-align:left}.track-change-overlay .Dropdown__item-TrackChange .Dropdown__item-description{font-size:10px;margin-top:4px}", ""]);

// exports
